let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("5UvRn")), load("9DJ7j")]).then(() => parcelRequire('kRz17'));